module.exports = __webpack_public_path__ + "img/icon_sensor_load_1.8afa343f.svg";